import { PermissionEnum } from "@core/consts/permissions";

export class BaseComponent {
  protected readonly PermissionEnum = PermissionEnum;
}
